import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import { useMutation } from 'react-query';
import PropTypes from 'prop-types';

export const blockUser = ({ id }) => {
  return axios.post(`/users/${id}/block`);
};

blockUser.propTypes = {
  id: PropTypes.string.isRequired,
};

export const useBlockUser = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onMutate: async (blockedUser) => {
      await queryClient.cancelQueries('activeUsers');

      const previousUsers = queryClient.getQueryData('activeUsers');

      queryClient.setQueryData(
        'activeUsers',
        previousUsers?.filter((user) => user.id !== blockedUser.id)
      );

      return { previousUsers };
    },
    onError: (_, __, context) => {
      if (context?.previousUsers) {
        queryClient.setQueryData('activeUsers', context.previousUsers);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('activeUsers');
      addNotification({
        type: 'success',
        title: 'User Blocked',
      });
    },
    ...config,
    mutationFn: blockUser,
  });
};
